import { Container } from 'inversify';
import config, { AppConfig } from './app-config';
import { CountryApiService } from 'src/api/taxonomies/countries-api';
import { IndustryAreaApiService } from 'src/api/taxonomies/industry-areas-api';
import { JobDomainApiService } from 'src/api/taxonomies/job-domains-api';
import { JobRoleApiService, JobRoleFormApiService } from 'src/api/taxonomies/job-roles-api';
import { JobRoleJobSkillApiService } from 'src/api/taxonomies/job-roles-job-skills-api';
import { JobSkillApiService } from 'src/api/taxonomies/job-skills-api';
import { LanguageApiService } from 'src/api/taxonomies/languages-api';
import { MethodologyApiService } from 'src/api/taxonomies/job-methodologies-api';
import { PersonProfileApiService, PersonProfileFormApiService } from 'src/api/person-profile/person-profile-api';
import { UsersApiService, UsersFormApiService } from 'src/api/identity/users-api';
import { MatchApiService, MatchFormApiService, MatchMeetingApiService, MatchMeetingFormApiService } from 'src/api/match/match-api';
import { OtpApiService } from 'src/api/otp/otp-api';
import { EnterpriseProfileApiService, EnterpriseProfileFormApiService } from 'src/api/enterprise-profile/enterprise-profile-api';
import { PersonFeatureApiService, PersonFeatureFromApiService, PersonProposalFromApiService } from 'src/api/feature/person-feature';
import { EnterpriseFeatureApiService, EnterpriseFeatureFromApiService, EnterpriseProposalFromApiService } from 'src/api/feature/enterprise-feature';
import {
  UserNotificationsApiService,
  UserNotificationsFormApiService,
  UserNotificationsFiltersApiService
} from 'src/api/notifications/notifications-api';
import { BugReportFormApiService } from 'src/api/bug-report/bug-report-api';
import { ContactFormApiService } from 'src/api/contact/contact-api';
import { PersonAccountCancellationApiService } from 'src/api/person-profile/account-cancellation-api';
import { HealthApiService } from 'src/api/health/health-api';
import { PaymentsConstantsConfigApiService } from 'src/api/payment-configuration/payments-constants-config-api';
import { TestimonialsApiService } from 'src/api/testimonials/testimonials-api';
import { PublicPersonSimulatorApiService } from 'src/api/observatory/public-person-simulator-api';
import { PublicEnterpriseSimulatorApiService, PublicEnterpriseSimulatorQueryApiService } from 'src/api/observatory/public-enterprise-simulator-api';
import { WorksApiService } from '../api/works/works';
import { ShortLinkApiService } from 'src/api/shortLink/short-link-api';
import { DraftShortlistApiService, DraftShortlistFormApiService } from 'src/api/draft-shortlist/draft-shortlist-api';
import { J2LContractApiService, J2LContractFromApiService } from 'src/api/contract/j2l-ontract-api';

const container = new Container();

export const initializeInversify = async () => {
  container.bind<AppConfig>(AppConfig).toConstantValue(config);

  if (config.envConfig?.logAll) {
    console.log('environment', config.envConfig);
  }

  const countryApiService = new CountryApiService();
  container.bind<CountryApiService>(CountryApiService).toConstantValue(countryApiService);
  container.bind<IndustryAreaApiService>(IndustryAreaApiService).toConstantValue(new IndustryAreaApiService());
  container.bind<JobDomainApiService>(JobDomainApiService).toConstantValue(new JobDomainApiService());
  container.bind<JobRoleApiService>(JobRoleApiService).toConstantValue(new JobRoleApiService());
  container.bind<JobRoleFormApiService>(JobRoleFormApiService).toConstantValue(new JobRoleFormApiService());
  container.bind<JobRoleJobSkillApiService>(JobRoleJobSkillApiService).toConstantValue(new JobRoleJobSkillApiService());
  container.bind<JobSkillApiService>(JobSkillApiService).toConstantValue(new JobSkillApiService());
  container.bind<LanguageApiService>(LanguageApiService).toConstantValue(new LanguageApiService());
  container.bind<MethodologyApiService>(MethodologyApiService).toConstantValue(new MethodologyApiService());
  container.bind<PersonProfileApiService>(PersonProfileApiService).toConstantValue(new PersonProfileApiService());
  container.bind<PersonProfileFormApiService>(PersonProfileFormApiService).toConstantValue(new PersonProfileFormApiService());
  container.bind<PersonAccountCancellationApiService>(PersonAccountCancellationApiService).toConstantValue(new PersonAccountCancellationApiService());
  container.bind<UsersApiService>(UsersApiService).toConstantValue(new UsersApiService());
  container.bind<UsersFormApiService>(UsersFormApiService).toConstantValue(new UsersFormApiService());

  container.bind<EnterpriseProfileApiService>(EnterpriseProfileApiService).toConstantValue(new EnterpriseProfileApiService());
  container.bind<EnterpriseProfileFormApiService>(EnterpriseProfileFormApiService).toConstantValue(new EnterpriseProfileFormApiService());

  container.bind<MatchApiService>(MatchApiService).toConstantValue(new MatchApiService());
  container.bind<MatchMeetingApiService>(MatchMeetingApiService).toConstantValue(new MatchMeetingApiService());
  container.bind<MatchFormApiService>(MatchFormApiService).toConstantValue(new MatchFormApiService());
  container.bind<MatchMeetingFormApiService>(MatchMeetingFormApiService).toConstantValue(new MatchMeetingFormApiService());

  container.bind<OtpApiService>(OtpApiService).toConstantValue(new OtpApiService());

  container.bind<J2LContractApiService>(J2LContractApiService).toConstantValue(new J2LContractApiService());
  container.bind<J2LContractFromApiService>(J2LContractFromApiService).toConstantValue(new J2LContractFromApiService());

  container.bind<PersonFeatureApiService>(PersonFeatureApiService).toConstantValue(new PersonFeatureApiService());
  container.bind<EnterpriseFeatureApiService>(EnterpriseFeatureApiService).toConstantValue(new EnterpriseFeatureApiService());
  container.bind<PersonFeatureFromApiService>(PersonFeatureFromApiService).toConstantValue(new PersonFeatureFromApiService());
  container.bind<EnterpriseFeatureFromApiService>(EnterpriseFeatureFromApiService).toConstantValue(new EnterpriseFeatureFromApiService());
  container.bind<PersonProposalFromApiService>(PersonProposalFromApiService).toConstantValue(new PersonProposalFromApiService());
  container.bind<EnterpriseProposalFromApiService>(EnterpriseProposalFromApiService).toConstantValue(new EnterpriseProposalFromApiService());

  container.bind<UserNotificationsApiService>(UserNotificationsApiService).toConstantValue(new UserNotificationsApiService());
  container.bind<UserNotificationsFormApiService>(UserNotificationsFormApiService).toConstantValue(new UserNotificationsFormApiService());
  container.bind<UserNotificationsFiltersApiService>(UserNotificationsFiltersApiService).toConstantValue(new UserNotificationsFiltersApiService());

  container.bind<BugReportFormApiService>(BugReportFormApiService).toConstantValue(new BugReportFormApiService());

  container.bind<ContactFormApiService>(ContactFormApiService).toConstantValue(new ContactFormApiService());

  container.bind<PaymentsConstantsConfigApiService>(PaymentsConstantsConfigApiService).toConstantValue(new PaymentsConstantsConfigApiService());

  container.bind<TestimonialsApiService>(TestimonialsApiService).toConstantValue(new TestimonialsApiService());

  container.bind<PublicPersonSimulatorApiService>(PublicPersonSimulatorApiService).toConstantValue(new PublicPersonSimulatorApiService());
  container.bind<PublicEnterpriseSimulatorApiService>(PublicEnterpriseSimulatorApiService).toConstantValue(new PublicEnterpriseSimulatorApiService());
  container
    .bind<PublicEnterpriseSimulatorQueryApiService>(PublicEnterpriseSimulatorQueryApiService)
    .toConstantValue(new PublicEnterpriseSimulatorQueryApiService());

  container.bind<WorksApiService>(WorksApiService).toConstantValue(new WorksApiService());

  container.bind<ShortLinkApiService>(ShortLinkApiService).toConstantValue(new ShortLinkApiService());
  container.bind<DraftShortlistApiService>(DraftShortlistApiService).toConstantValue(new DraftShortlistApiService());
  container.bind<DraftShortlistFormApiService>(DraftShortlistFormApiService).toConstantValue(new DraftShortlistFormApiService());

  if (config?.envConfig?.name !== 'local') {
    const healthApiService = new HealthApiService();
    await healthApiService.waitForHealthyBackendServices();
  }

  await countryApiService.loadCache();
};

export default container;
